import React, { useState } from 'react';
import { Mail, ArrowRight, Check } from 'lucide-react';
import subscriptionApi from '../services/subscriptionApi';

const FooterSubscription = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const result = await subscriptionApi.subscribe(email, '', 'general', ['ministry_updates']);
      console.log('Footer subscription successful:', result);
      setIsSubmitted(true);
      setEmail('');
      
      // Reset after 4 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 4000);
    } catch (err) {
      setError('Please try again');
      console.error('Footer subscription error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="bg-gradient-to-r from-[#f17b21] to-[#ff9649] rounded-xl p-6 text-white text-center">
        <div className="flex items-center justify-center space-x-2 mb-3">
          <Check className="w-6 h-6" />
          <h3 className="text-lg font-bold font-display">Thank you for subscribing!</h3>
        </div>
        <p className="text-white/90 font-sans">You'll receive spiritual encouragement in your inbox.</p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-[#f17b21] to-[#ff9649] rounded-xl p-6 text-white">
      <div className="flex items-center justify-center mb-4">
        <Mail className="w-8 h-8 mr-3" />
        <div>
          <h3 className="text-lg lg:text-xl font-bold font-display">Join Our Community</h3>
          <p className="text-white/90 text-sm lg:text-base font-sans">Get weekly spiritual insights and ministry updates</p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="w-full px-4 py-3 rounded-lg text-gray-800 placeholder-gray-500 focus:ring-2 focus:ring-white focus:outline-none font-sans"
            required
          />
          {error && (
            <p className="text-white/80 text-xs mt-1 font-sans">{error}</p>
          )}
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-white text-[#f17b21] hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-colors duration-300 disabled:opacity-70 disabled:cursor-not-allowed font-sans flex items-center justify-center space-x-2 whitespace-nowrap"
        >
          {isSubmitting ? (
            <>
              <div className="animate-spin w-4 h-4 border-2 border-[#f17b21] border-t-transparent rounded-full"></div>
              <span>Subscribing...</span>
            </>
          ) : (
            <>
              <span>Subscribe</span>
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </button>
      </form>
      
      <p className="text-white/80 text-xs mt-3 text-center font-sans">
        Join our community for weekly spiritual encouragement • Unsubscribe anytime
      </p>
    </div>
  );
};

export default FooterSubscription;